<main role="main" class="not-home-page">
  <section class="c-erreur404">
    <div class="container">
      <div class="row d-flex">
        <div class="col-md-5 order-md-2">
          <p class="text404">404</p>
        </div>
        <div class="col-md-7 order-md-1">
          <h3>{{'page404.Ligne1' | translate}}</h3>
          <p>{{'page404.Ligne2' | translate}}</p>
          <a class="btn btn-info" href="javascript:void(0)" [routerLink]="['/']" routerLinkActive="router-link-active" >{{'page404.Bouton' | translate}}</a>  
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-md-12">
          <p class="para404">{{'page404.Ligne3' | translate}} <a [routerLink]="['/acces-rapide/contact'] "href="javascript:void(0)">{{'page404.NousContacter' | translate}}</a> {{'page404.Ligne4' | translate}}</p>
        </div>
      </div>
    </div>
  </section>
</main>
